import { useMemo } from 'react';
import classNames from 'classnames';
import { type BreadcrumbItem } from '@/containers';
import { Link } from 'react-router-dom';

type BreadcrumbProps = {
	readonly className?: string;
	readonly items: BreadcrumbItem[];
};
const classNameComponent = 'c-cnm-breadcrumb';

export const Breadcrumb = ({ className, items }: BreadcrumbProps) => {
	const wrapperClassName = useMemo(() => classNames(classNameComponent, className), [className]);

	return (
		<nav className={wrapperClassName} aria-label="Breadcrumb">
			<div className="o-container">
				<ul className={`${classNameComponent}__list`}>
					<li className={`${classNameComponent}__item`}>
						<Link to="/">Inicio</Link>
					</li>
					{items.map((item) => (
						<li key={`${item.label}`} className={`${classNameComponent}__item`}>
							{item.to ? <Link to={item.to}>{item.label}</Link> : <span>{item.label}</span>}
						</li>
					))}
				</ul>
			</div>
		</nav>
	);
};
